import React, { Component } from "react";
import { connect } from "react-redux";
import { assessmentActions, userActions } from "../../../_actions";
import Dashboard from "../Dashboard/Dashboard";
import Heading from "../../AdminPanel/Component/UI/Heading";
import SearchBox from "../../AdminPanel/Component/UI/SearchBox";
import AddCampaignsModal from "./Component/AddCampaignsModal";
import UpdateCampaignsModal from "./Component/UpdateCampaignsModal";
import { MdArrowForwardIos, MdArrowBackIos } from "react-icons/md";
import moment from "moment";
class Settings extends Component {

  constructor(props) {
    super(props);
    this.state = {
      addCampaignsModal: false,
      updateUserModal: false,
      openOrderId: null,
      entries: 20,
      data: Array.from({ length: 10 }, (_, i) => ({
        id: i + 1,
        campaignname: "Campaign 1",
        launchdate: "Jan 01, 2026 10:52 AM",
        lastreminderdate: "Jany 14, 2026 10:52 AM",
        createdby: "hari@mailinator.com",
        // status: i === 2 ? "Pending" : "Completed",
      })),
      pageNo: 1,
      size: 10,
      keyWord: ""
    };
  }

  componentDidMount() {
    this.props.dispatch(assessmentActions.userAssessmentUserProfile());
    this.props.dispatch(assessmentActions.getAssessmentCartCount());
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    this.props.dispatch(assessmentActions.getOrderBookList({
      "keyWord": '',
      "pageNo": 1,
      "size": this.state.size
    }));
    this.callUserListAPI();
    window.scrollTo(0, 0);
  }

  openAddCampaignsModal = () => {
    console.log("Opening Add User Modal");
    this.setState({ addCampaignsModal: true }, () => {
      console.log("Modal state updated:", this.state.addCampaignsModal);
    });
  };

  closeAddCampaignsModal = () => {
    console.log("Closing Add User Modal");
    this.setState({ addCampaignsModal: false });
  };

  // Handle entries dropdown change
  handleEntriesChange = (value) => {
    this.setState({ entries: value });
  };

  // Open modal
  openUpdateCampaignsModal = () => {
    this.setState({ updateUserModal: true });
  };

  // Close modal
  closeUpdateCampaignsModal = () => {
    this.setState({ updateUserModal: false });
  };

  // Reupload handler
  handleReupload = () => {
    console.log("Reupload clicked");
    this.setState({ updateUserModal: false });
  };

  toggleOrder = (id) => {
    this.setState((prevState) => ({
      openOrderId: prevState.openOrderId === id ? null : id,
    }));
  };

  handleRedirect = (path) => {
    this.props.history.push(path);
  };

  callUserListAPI = () => {
    const { pageNo, size, keyWord } = this.state;
    this.props.dispatch(
      assessmentActions.getOrderBookList({
        pageNo,
        size,
        keyWord
      })
    );
  };

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState.pageNo !== this.state.pageNo ||
      prevState.size !== this.state.size ||
      prevState.keyWord !== this.state.keyWord
    ) {
      this.callUserListAPI();
    }
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "keyWord": value,
      "pageNo": this.state.pageNo,
      "size": this.state.size
    }
    this.props.dispatch(assessmentActions.getOrderBookList(data));
  }

  handleSizeChange = (e) => {
    this.setState({
      size: Number(e.target.value),
      pageNo: 1
    });
  };

  goPrev = () => {
    this.setState((prev) => ({
      pageNo: Math.max(prev.pageNo - 1, 1)
    }));
  };

  goNext = () => {
    const { getOrderBookListDataTotal } = this.props.assessment;
    const totalPages = Math.ceil(getOrderBookListDataTotal / this.state.size);
    this.setState((prev) => ({
      pageNo: Math.min(prev.pageNo + 1, totalPages)
    }));
  };


  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  switchToSelf = () => {
    this.props.dispatch(userActions.userCoachSwitchLogin({}, this.props));
  };

  render() {

    let { assessment } = this.props;
    let { userAssessmentUserProfileData, getOrderBookListData, getOrderBookListDataTotal, userAssessmentOrdersData, userAssessmentResponseAnalyticsData, getAssessmentPackagesShortListData, getAssessmentCartCountData
    } = assessment;

    const { addCampaignsModal, updateUserModal, entries, openOrderId, data, pageNo, size } = this.state;

    function getDetails(orderBook, field, type, orderPack) {
      if (type === 2) {
        return field &&
          orderPack &&
          orderPack["productId"] &&
          orderPack["productId"][field]
          ? orderPack["productId"][field]
          : "";
      } else if (type === 3) {
        return field && orderPack && orderPack[field] ? orderPack[field] : "";
      } else {
        return field && orderBook && orderBook[field] ? orderBook[field] : "";
      }
    }

    const start = getOrderBookListDataTotal === 0 ? 0 : (pageNo - 1) * size + 1;
    const end = Math.min(pageNo * size, getOrderBookListDataTotal);
    const totalPages = Math.ceil(getOrderBookListDataTotal / size);

    const getPeriod = () => {
      const hour = moment().hour(); // 0–23

      if (hour >= 5 && hour < 12) return "Morning";
      if (hour >= 12 && hour < 17) return "Afternoon";
      if (hour >= 17 && hour < 21) return "Evening";
      return "Night";
    };

    let userDetails = {
      name: userAssessmentUserProfileData?.name ?? "",
      email: userAssessmentUserProfileData?.email ?? "",
      period: getPeriod()
    };

    let { loading } = assessment;
    return (
      <Dashboard userDetails={userDetails} logout={this.logout} switchToSelf={this.switchToSelf} loading={loading}>
        <div className="space-y-6 p-8">
          {/* Header Row */}
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Heading className="text-xl" title="Setting" />
            </div>
          </div>

          <button className="pb-2 text-base font-semibold text-black">Billing History</button>

          {/* Tabs */}
          {/* <div className="border-b border-gray-200 mb-6">
            <nav className="flex space-x-8">
           
              <button onClick={() => this.handleRedirect('/assessment/assessment-codes')} className="pb-3 text-sm font-medium textlight hover:text-gray-700">
                Assessment Codes
              </button>
            </nav>
          </div> */}

          {/* Controls */}
          <div className="flex justify-between items-center mb-4">
            <div className="flex items-center gap-2 text-sm textblack">
              Show
              <select value={this.state.size} onChange={this.handleSizeChange} className="border rounded-md px-2 py-1">
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
              </select>
              entries
            </div>

            <div className="flex items-center gap-3 text-sm textblack">
              <div className="">
                <SearchBox
                  value={this.state.keyWord}
                  onChange={this.handleSearch}
                  placeholder="Search"
                />
              </div>
              <div>{start}-{end} of {getOrderBookListDataTotal}</div>
              <div onClick={this.goPrev} disabled={this.state.pageNo === 1} className={`p-2 rounded-md ${this.state.pageNo === 1 ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                <MdArrowBackIos size={20} />
              </div>
              <div onClick={this.goNext} disabled={this.state.pageNo === totalPages} className={`p-2 rounded-md ${this.state.pageNo === totalPages ? "opacity-40 cursor-not-allowed" : "bglightcolor textcolor"}`}>
                <MdArrowForwardIos size={20} />
              </div>
            </div>
          </div>


          <div className="space-y-4">
            {getOrderBookListData && getOrderBookListData.length > 0 ? (
              getOrderBookListData.map((orderBook, index) => {
                const orderId = getDetails(orderBook, "orderNumber") || index;
                const isOpen = openOrderId === orderId;
                const orderPacks = getDetails(orderBook, "orderPacks") || [];

                return (
                  <div
                    key={orderId}
                    className={`bg-white rounded-md transition-all duration-200 ${isOpen ? "border border-blue-400" : "border border-gray-200"
                      }`}
                  >
                    {/* 🔹 Order Header */}
                    <div
                      className="p-4 flex items-center justify-between cursor-pointer"
                      onClick={() => this.toggleOrder(orderId)}
                    >
                      <div className="space-y-2">
                        <p className="font-medium textblack text-lg">
                          Order No: #{getDetails(orderBook, "orderNumber")}
                        </p>
                        <p className="text-base textlight">
                          Order Placed On:{" "}
                          {moment(
                            new Date(parseInt(getDetails(orderBook, "createdAt")))
                          )
                            .utcOffset("+05:30")
                            .format("ddd, Do MMM YYYY, hh:mm A")}
                        </p>
                      </div>

                      <div className="flex items-center gap-4">
                        <span className="text-base font-medium textblack">
                          {orderPacks.length} items
                        </span>
                        <button
                          className={`p-2 rounded-md flex items-center justify-center transition ${isOpen
                            ? "bglightcolor textcolor"
                            : "bg-[#F1F5F9] hover:bg-gray-200 textblack"
                            }`}
                        >
                          {isOpen ? (
                            <MdArrowBackIos size={20} className="rotate-90" />
                          ) : (
                            <MdArrowForwardIos size={20} className="rotate-90" />
                          )}
                        </button>
                      </div>
                    </div>

                    {/* 🔹 Items Section */}
                    {isOpen && (
                      <>
                        <div className="divide-y divide-gray-200 bg-[#F9FAFB] p-4">
                          {orderPacks.map((orderPack, i) => (
                            <div
                              key={i}
                              className="flex items-center justify-between py-4 text-sm"
                            >
                              <p className="text-lg font-medium textblack w-72">
                                {getDetails({}, "name", 2, orderPack)}
                              </p>
                              <p className="text-lg font-medium textblack">
                                Qty {getDetails({}, "quantity", 3, orderPack)}
                              </p>
                              <p className="text-lg font-medium textblack">
                                ₹ {getDetails({}, "total", 3, orderPack)}
                              </p>
                            </div>
                          ))}
                        </div>

                        {/* 🔹 Total Section */}
                        <div className="flex items-center justify-between p-4 border-t">
                          <p className="text-lg font-semibold textblack">Total Paid</p>
                          <p className="text-lg font-semibold textblack">
                            ₹ {getDetails(orderBook, "total")}
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                );
              })
            ) : (
              <div className="flex items-center justify-center">
                <div className="text-center py-8">
                  <div className="flex flex-col items-center justify-center text-gray-500">
                    <h1 className="text-lg font-semibold">No Data Found</h1>
                    <p className="text-sm mt-1">Try adjusting your search or filters</p>
                  </div>
                </div>
              </div>
            )}
          </div>

        </div>

        {
          addCampaignsModal && (
            <AddCampaignsModal onClose={this.closeAddCampaignsModal} />
          )
        }

        {
          updateUserModal && (
            <UpdateCampaignsModal
              isOpen={this.openUpdateCampaignsModal}
              onClose={this.closeUpdateCampaignsModal}
              onReupload={this.handleReupload}
            />
          )
        }

      </Dashboard >
    );
  }
}

function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(Settings);

